module.exports = __webpack_public_path__ + "static/media/blacklogo.7eeea462.png";